import {
  Box,
  Container,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import CustomButton from 'Components/CustomButton/CustomButton'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { makeGetRequest } from 'utils/api'
import { convertToUserDateFormate } from 'utils/helpers'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import { DoneAll, MarkAsUnreadOutlined } from '@mui/icons-material'
import { makePostRequest } from 'utils/api'
import CreateEvent from './CreateEvent'
import CreateTask from './CreateTask'

export default function MyTraning() {
  const [operations, setOperations] = useState({})
  const [selectedRows, setSelectedRows] = useState([])

  useEffect(() => {
    fetchOperations()
  }, [])

  const fetchOperations = async () => {
    let url = `/api/Professional/get-tranings/`

    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setOperations({ results: response.data, count: response.data.length })
    }
  }
  const deleteBankAccount = async (e) => {
    if (selectedRows.length === 0) {
      alert('Please Select document...')
    } else {
      await makePostRequest(
        '/api/Professional/delete-tranings/',
        {
          ids: selectedRows,
        },
        {},
        true,
      )
      fetchOperations()
    }
  }
  const handelStatus = async (status) => {
    if (selectedRows.length === 0) {
      alert('Please Select document...')
    } else {
      await makePostRequest(
        '/api/Professional/tranings-status-update/',
        {
          ids: selectedRows,
          status: status,
        },
        {},
        true,
      )
      fetchOperations()
    }
  }
  return (
    <Container maxWidth="xl">
      <Box justifyContent="flex-end" padding={2} display="flex">
        <Box display={'flex'}>
          <CustomButton onClick={() => handelStatus('Accepter')}>Accepter</CustomButton>
          <CustomButton onClick={() => handelStatus('Signer')}>Signer</CustomButton>
          <CustomButton onClick={() => handelStatus('Refuser')}>Refuser</CustomButton>
          <CustomButton onClick={deleteBankAccount}>Supprimer</CustomButton>
        </Box>
      </Box>

      <ListOperations
        fetchOperations={fetchOperations}
        setSelectedRows={setSelectedRows}
        operations={operations}
      />
    </Container>
  )
}

function ListOperations({ fetchOperations, operations, setSelectedRows }) {
  const siteUser = useSelector((store) => store.user)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [createTache, setCreateTache] = useState(false)
  const [createEvent, setCreateEvent] = useState(false)
  const [selectedJob, setSelectedJob] = useState('')
  const [rows, setRows] = useState(20)

  const toggleModal = () => {
    setCreateEvent(false)
  }

  const columns = [
    // { field: 'id', headerName: 'ID', width: 90 },
    {
      field: 'title',
      headerName: 'Intitulé d formation',
      width: 180,
      valueGetter: (params) => `${params.row.myTraning.title}`,
    },
    {
      field: 'company_name',
      headerName: 'Enreprise',
      width: 180,
      editable: true,
      renderCell: (params) => `${params.row.myTraning.provider}`,
    },
    {
      field: 'salary_range',
      headerName: 'Durée',
      width: 150,
      editable: true,
      valueGetter: (params) => `${params.row.myTraning.duration}`,
    },

    {
      field: 'startdate',
      headerName: 'Start Date',
      width: 150,
      editable: false,
      valueGetter: (params) =>
        convertToUserDateFormate(
          siteUser.user,
          moment(params.row.myTraning.start_date).format('MMMM Do YYYY'),
        ),
    },
    {
      field: 'enddate',
      headerName: 'End Date',
      width: 150,
      editable: false,
      valueGetter: (params) =>
        convertToUserDateFormate(
          siteUser.user,
          moment(params.row.myTraning.end_date).format('MMMM Do YYYY'),
        ),
    },
    {
      field: 'applied_date',
      headerName: 'Date de ccandidature',
      width: 150,
      editable: false,
      valueGetter: (params) =>
        convertToUserDateFormate(
          siteUser.user,
          moment(params.row.applied_date).format('MMMM Do YYYY'),
        ),
    },
    {
      field: 'status',
      headerName: 'Statut',
      width: 180,
      editable: true,
      renderCell: (params) => {
        let status = params.row.status
        let color = 'green'
        if (status === 'Enregistré') color = '#e5aa20'

        if (status === 'Refuser') color = 'red'
        return (
          <Box color={color} fontWeight={700}>
            {status}
          </Box>
        )
      },
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 150,
      editable: true,
      renderCell: (params) => {
        return (
          <Stack direction="row" spacing={1}>
            <IconButton>
              <MarkAsUnreadOutlined />
            </IconButton>
            <IconButton
              onClick={() => {
                setSelectedJob(params.row.myTraning.title)
                setCreateTache(true)
              }}
            >
              <DoneAll />
            </IconButton>
            <IconButton
              onClick={() => {
                setSelectedJob(params.row.myTraning.title)
                setCreateEvent(true)
              }}
            >
              <CalendarMonthIcon />
            </IconButton>
          </Stack>
        )
      },
    },
  ]
  return (
    <>
      {createEvent && <CreateEvent toggleModal={toggleModal} title={selectedJob} />}
      {createTache && <CreateTask setCreateTache={setCreateTache} title={selectedJob} />}
      <Box
        style={{
          width: '100% ',
          background: 'white',
          borderRadius: '5px',
        }}
      >
        <Typography
          variant="h6"
          sx={{
            flex: '1 1 100%',
            id: 'tableTitle',
            fontWeight: 600,
            padding: '10px',
            component: 'div',
            color: 'black',
          }}
        >
          Mes formations ({operations.count})
        </Typography>

        <DataGrid
          sx={{ height: '70vh' }}
          rows={operations.results ? operations.results : []}
          columns={columns}
          pageSize={rows}
          rowCount={operations.count ? operations.count : 0}
          rowsPerPageOptions={[10, 20, 40]}
          pagination
          onSelectionModelChange={(itm) => setSelectedRows([...itm])}
          checkboxSelection
          disableSelectionOnClick
        />
      </Box>
    </>
  )
}
